import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import CatalogSettingsComponent from '../components/catalog.component';
import { selectCatalogSettingsQueryItems } from '../../../../../redux/catalog-settings/selector';
import { catalogSettings } from '../../../../../redux/catalog-settings/action';

const ManagementCatalogSettings = () => {
  const dispatch = useAppDispatch()
  const catalogSettingsQuery = useSelector(selectCatalogSettingsQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [selectCatalogSettings, setSelectCatalogSettings] = useState<any>([])

  const fetchCatalogSettingsQueryById = () => {
    dispatch(catalogSettings.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v3.0/settings/catalog/query`,
      entity: 'catalogSettings',
      jsonData: {
        Records: [
          {
            Id: 0
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectCatalogSettings({ ...selectCatalogSettings, [fields[0]]: value });
  }

  useEffect(
    () => {
      fetchCatalogSettingsQueryById()
      setIsLoading(false)
    }, []
  )

  useEffect(
    () => {
      if (isQuery) {
        setSelectCatalogSettings(catalogSettingsQuery?.result?.items)
      }
    }, [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    await dispatch(catalogSettings.resetAction({ actionType: 'update' }))
    await dispatch(catalogSettings.update({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v3.0/settings/catalog`,
      entity: 'catalogSettings',
      jsonData: {
        Records: [
          selectCatalogSettings
        ]
      }
    }))
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <CatalogSettingsComponent
          handleInnerFormChange={handleInnerFormChange}
          selectCatalogSettings={selectCatalogSettings}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  )
};

export default ManagementCatalogSettings;